import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React from "react";

import filledGreenOvalSrc from "../../assets/images/filled-green-oval.png";
import ourCommitmentSrc from "../../assets/images/evrgree-commitment.png";
import styled from "styled-components";

import {
  BackgroundImageContainer,
  SlideContainer as Container,
  Paragraph,
  RegularGreenOval,
  Title,
} from "./OurCommitment.styles";


const EvrGreenBody = () => {
  const { t } = useTranslation();
  const theme = useTheme();
 
  return (
    <>
      <Title theme={theme}>{t("Sustainability Matters.")}</Title>
      <Paragraph theme={theme}>
        {t(
          "That's why we made the evr-green commitment. We believe consumers should not have to choose between getting a good nights rest and preserving the environment."
        )}
      </Paragraph>
      <Paragraph theme={theme}>
        {t(
          "Through years of industry experience and innovation, we have developed a mattress that delivers the quality sleep you deserve while reducing environmental impact."
        )}
      </Paragraph>
    </>
  );
};

const SlideContainer = styled(Container)`
`;

const OurCommitmentSlide1 = () => {
  //Media Queries
  return (
    <SlideContainer style={{ padding: "120px 20px 0px 20px"}}>
      <BackgroundImageContainer>
        <FilledGreenOval />
        <RegularGreenOval />
      </BackgroundImageContainer>
      <EvrGreenImage />
      <EvrGreenBody />
    </SlideContainer>
  );
};

const FilledGreenOval = styled.img.attrs({
  src: filledGreenOvalSrc,
})`
position: absolute;
width: 146px;
top: -76px;
left: 221px;
@media (max-width: 468px) {
  width: 100px;
  left: 157px;
}
`;
const EvrGreenImage = styled.img.attrs({
  src: ourCommitmentSrc,
})`
height: 70px;
mergin-bottom:-60px; 
@media (max-width: 468px) {
  height: 50px;
}
`;
export default OurCommitmentSlide1;
